export enum MedicationUnitType {
    L = 1,
    ML = 2,
    Doses = 3
}
export const MedicationUnitOptions = [
    {label: 'L (Liters)', value: MedicationUnitType.L},
    {label: 'ml (Milliliters)', value: MedicationUnitType.ML},
    {label: 'Doses', value: MedicationUnitType.Doses}
];
